import { render, staticRenderFns } from "./PromotionCreate.vue?vue&type=template&id=150caef8&"
import script from "./PromotionCreate.vue?vue&type=script&lang=ts&"
export * from "./PromotionCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports